module.exports = "<div ui-view=main id=mainview></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/subscriptions/subscriptions.html
// module id = 510
// module chunks = 0